var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screen screen__videos"},[_c('training-videos-listing',{attrs:{"sm":8,"videos":_vm.videos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }